export const progress = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "center",
};

export const progressItem = ({ isSelected = false, hasValues = false }) => ({
  background: hasValues ? "primary" : isSelected ? "black" : "grey9",
  border: "solid 1px",
  borderColor:
    isSelected && hasValues ? "primary" : isSelected ? "black" : "white",
  width: "22px",
  height: "6px",

  "&:first-of-type": {
    borderTopLeftRadius: "100px",
    borderBottomLeftRadius: "100px",
  },

  "&:last-of-type": {
    borderTopRightRadius: "100px",
    borderBottomRightRadius: "100px",
  },
});
